/* eslint-disable no-underscore-dangle */
import { createFieldState } from './helpers';

const createReducer = (initialState) => {
  return (currentState, action) => {
    switch (action.type) {
      case 'INITIALIZE':
        return action.payload;

      case 'SET_FIELD': {
        return {
          ...currentState,
          fields: {
            ...currentState.fields,
            [action.payload.fieldName]: {
              ...currentState.fields[action.payload.fieldName],
              ...action.payload.value,
            },
          },
        };
      }

      case 'SET_FORM':
        return {
          ...currentState,
          fields: action.payload,
        };

      case 'SET_VALIDATORS':
        return {
          ...currentState,
          fields: {
            ...currentState.fields,
            [action.payload.fieldName]: {
              ...currentState.fields[action.payload.fieldName],
              validators: action.payload.validators,
            },
          },
        };

      case 'RESET_FIELD':
        return {
          ...currentState,
          fields: {
            ...currentState.fields,
            [action.payload.fieldName]: {
              ...currentState.fields[action.payload.fieldName],
              value: initialState[action.payload.fieldName].value,
              touched: initialState[action.payload.fieldName].touched,
              valid: initialState[action.payload.fieldName].valid,
              errors: initialState[action.payload.fieldName].errors,
              validators: initialState[action.payload.fieldName].validators,
            },
          },
        };

      case 'ADD_GROUP_INSTANCE': {
        const { groupName, instanceId, schema } = action.payload;
        const newFields = { ...currentState.fields };

        schema.forEach((fieldSchema) => {
          const fieldName = `${groupName}_${instanceId}_${fieldSchema.fieldName}`;
          const fieldState = createFieldState(fieldSchema, fieldSchema.value);
          newFields[fieldName] = {
            ...fieldState,
            name: fieldName, // Override with the full field name
            _groupName: groupName,
            _groupId: instanceId,
            _fieldKey: fieldSchema.fieldName,
          };
        });

        const newGroupInstances = {
          ...currentState.groupInstances,
          [groupName]: [...currentState.groupInstances[groupName], instanceId],
        };

        return {
          ...currentState,
          fields: newFields,
          groupInstances: newGroupInstances,
        };
      }

      case 'REMOVE_GROUP_INSTANCE': {
        const { groupName, instanceId } = action.payload;
        const newFields = { ...currentState.fields };

        Object.keys(newFields).forEach((fieldName) => {
          if (newFields[fieldName]._groupName === groupName
            && newFields[fieldName]._groupId === instanceId) {
            delete newFields[fieldName];
          }
        });

        const newGroupInstances = {
          ...currentState.groupInstances,
          [groupName]: currentState.groupInstances[groupName].filter(
            (id) => id !== instanceId,
          ),
        };

        return {
          ...currentState,
          fields: newFields,
          groupInstances: newGroupInstances,
        };
      }

      default:
        return currentState;
    }
  };
};

export default createReducer;
